import { EditGARTask, GARTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGarLibraryFields } from "../schema/gar-schema-library";

export const getGarSchema = ({
  type,
}: {
  type: FormType | undefined;
}): SchemaForFormData<GARTask> => ({
  type: "object",
  title: `GAR registratie ${getTitleAddon(type)}`,
  description: `Dit is het GAR formulier. Voeg een Excel of csv toe om te starten. ${getDocsLinkMarkdown(
    "GAR"
  )}`,
  required: ["projectNumber", "fieldworkFile", "labFile", "metadata"],
  properties: {
    ...pickGarLibraryFields(["fieldworkFile", "labFile", "projectNumber"]),
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "qualityRegime",
        "samplingOperator",
        "samplingStandard",
        "qualityControlMethod",
        "responsibleLaboratoryKvk",
        "deliveryAccountableParty",
      ],
      properties: pickGarLibraryFields([
        "qualityRegime",
        "samplingOperator",
        "samplingStandard",
        "qualityControlMethod",
        "responsibleLaboratoryKvk",
        "deliveryAccountableParty",
        "groundwaterMonitoringNets",
      ]),
    },
  },
});

export const getEditGarSchema = ({
  type,
}: {
  type: FormType | undefined;
}): SchemaForFormData<EditGARTask> => ({
  type: "object",
  title: `GAR registratie ${getTitleAddon(type)}`,
  description: `Dit is het GAR-Vervangen formulier. Wijzig hier de gewenste gegevens om een correctie aan te leveren. Voor meer informatie over welk parameter-id gekoppeld is aan welke stof verwijzen we naar de documentatie pagina van de BRO. ${getDocsLinkMarkdown(
    "GAR"
  )}`,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "broId",
        "deliveryAccountableParty",
        "qualityRegime",
        "correctionReason",
      ],
      properties: {
        ...pickGarLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGarLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: {
      type: "object",
      title: "Brondocumentgegevens",
      required: [
        "objectIdAccountableParty",
        "gmwBroId",
        "tubeNumber",
        "qualityControlMethod",
        "fieldResearch",
        "laboratoryAnalyses",
      ],
      properties: pickGarLibraryFields([
        "objectIdAccountableParty",
        "gmwBroId",
        "tubeNumber",
        "qualityControlMethod",
        "fieldResearch",
        "laboratoryAnalyses",
      ]),
    },
  },
});
